<div class="min-h-screen flex items-center justify-center bg-gray-200 px-4">
  <div class="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
    <h1 class="text-2xl font-semibold mb-1">Sign in</h1>
    <p class="text-sm text-gray-600 mb-6">Welcome back to the Saltus partner portal.</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1" for="email">Email</label>
        <input id="email" type="email" formControlName="email"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          autocomplete="email" />
      </div>

      <div>
        <div class="flex items-center justify-between mb-1">
          <label class="block text-sm font-medium text-gray-700" for="password">Password</label>
          <a routerLink="/forgot-password" class="text-sm text-blue-600 hover:underline">Forgot?</a>
        </div>
        <input id="password" type="password" formControlName="password"
          class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          autocomplete="current-password" />
      </div>

      <button type="submit" [disabled]="form.invalid || isSubmitting"
        class="w-full bg-blue-600 text-white font-medium py-2 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ isSubmitting ? 'Signing in…' : 'Sign in' }}
      </button>
    </form>

    <!-- Future SSO buttons go below this divider. Leave the block in place. -->
    <div class="mt-8 border-t border-gray-200 pt-6 hidden" data-sso-placeholder>
      <!-- e.g. <button (click)="auth.loginWithProvider('Google')">Sign in with Google</button> -->
    </div>
  </div>
</div>
